import { LitElement, html, css } from "lit";
import dayjs from "dayjs";
import language from "#scripts/translation";

export class MyPageInvoices extends LitElement {
  static properties = {
    yearfilter: { reflect: true },
    paidfilter: { reflect: true },
  };

  static styles = css`
    :host {
      width: 100%;
    }
    .invoices {
      display: flex;
      border-top: 2px solid rgba(0, 0, 0, 0.2);
      padding-top: 65px;
      margin-top: 30px;
      @media(max-width: 768px) {
        flex-direction: column;
        border-top: none;
        padding-top: 0px;
        margin-top: 0px;
      }
    }
    `;

  render () {
    return html`
        <div class="invoices"  @invoices-filtered-year=${this._handleYearFilter} @invoices-filtered-paid=${this._handlePaidFilter}>
          <slot></slot>
      </div>`;
  }

  _handleYearFilter (e) {
    this.yearfilter = e.detail.message;
    // update all children that uses filter
    const invoicesList = document.querySelector("mypage-invoices-list");
    invoicesList.yearfilter = this.yearfilter;
  }

  _handlePaidFilter (e) {
    this.paidfilter = e.detail.message;
    // update all children that uses filter
    const invoicesList = document.querySelector("mypage-invoices-list");
    invoicesList.paidfilter = this.paidfilter;
  }
}

export class MyPageInvoicesFilter extends LitElement {
  static properties = {
    label: {},
    message: {},
  };

  static styles = css`
    .filter {
      width: 240px;
      position: relative;
      padding: 0px;
      display: flex;
      flex-direction: column;
      gap: 30px;
      align-items: flex-start;
      justify-content: flex-start;
      width: 100%;
      @media(max-width: 768px) {
        display: none;
        gap: 20px;
        width: auto;
        border-radius: 6px;
        padding: 20px;
        background: rgb(255 255 255 / .8);
        margin-bottom: 20px;
      }
    }
    .filter-toggle {
      font-size: 1rem;
      display: flex;
      justify-content: flex-end;
      padding-bottom: 10px;
      & div {
        display: flex;
      }
      & svg {
        position: relative;
      }
      @media(min-width: 768px) {
        display: none;
      }
      &.active svg {
        transform: rotate(180deg);
      }
      &.active + .filter {
        display: flex;
      }
    }
    .filter-header {
      color: #000000;
      font-size: var(--raelingen-h3-font-size, 20px);
      font-weight: var(--raelingen-h3-font-weight, 600);
    }
    .filter-group {
      display: flex;
      flex-direction: column;
      gap: 0px;
      align-items: flex-start;
      justify-content: flex-start;
      flex-shrink: 0;
      position: relative;
      margin-top:  10px;
    }
    .filter-title {
      display: flex;
      height: 50px;
      align-content: center;
      flex-wrap: wrap;
    }
    .dato {
      color: #000000;
      text-align: left;
      font-family: var(--trekkspill-tekst-font-family, "Roboto-Medium", sans-serif);
      font-size: var(--trekkspill-tekst-font-size, 18px);
      line-height: var(--trekkspill-tekst-line-height, 24px);
      font-weight: var(--trekkspill-tekst-font-weight, 500);
      position: relative;
    }
    .cells {
      display: flex;
      width: 292px;
      flex-direction: column;
    }
    .check-cell {
      padding: 14px 0;
      @media(max-width: 768px) {
        padding: 16px 0;
      }
    }
    .check {
      display: flex;
      gap: 10px;
    }
    input[type=checkbox],
    input[type=radio] {
        transform: scale(1.5);
        accent-color: var(--black__text);
    }
    `;

  constructor() {
    super();
    this.message = this.defaultMessage;
  }

  defaultMessage = "";

  render () {
    return html`   
    <div class="filter-toggle" @click=${this._handleFilterToggle}>
      <div>Filter</div>
      <svg xmlns="http://www.w3.org/2000/svg" height="24px" width="24px" viewBox="0 -960 960 960" fill="var(--black__text)"><path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z"/></svg>
    </div>
    <div class="filter">
      <div class="filter-header">${language("MYPAGE_INVOICE_FILTER_TITLE")}</div>
      <div class="filter-group">
        <div class="filter-title">
          <div class="dato">${language("MYPAGE_INVOICE_FILTER_STATE")}</div>
        </div>
        <div class="cells">
          <div class="check-cell">
            <label class="check"><input type="radio" name='paid_filter' @click=${this._handlePaidCheck} data-filtervalue='' checked>${language("MYPAGE_INVOICE_FILTER_STATE_ALL")}</label>          </div>
          <div class="check-cell">
            <label class="check"><input type="radio" name='paid_filter' @click=${this._handlePaidCheck} data-filtervalue='YES'>${language("MYPAGE_INVOICE_FILTER_STATE_PAID")}</label>
          </div>
          <div class="check-cell">
            <label class="check"><input type="radio" name='paid_filter' @click=${this._handlePaidCheck} data-filtervalue='NO'>${language("MYPAGE_INVOICE_FILTER_STATE_NOTPAID")}</label>
          </div>
        </div>
      </div>
      <div class="filter-group">
        <div class="filter-title">
          <div class="dato">${language("MYPAGE_INVOICE_FILTER_YEAR")}</div>
        </div>
        <div class="cells">
          <div class="check-cell">
            <label class="check"><input type="radio" name='year_filter' @click=${this._handleYearCheck} data-filtervalue=${new Date().getFullYear()} checked>${new Date().getFullYear()}</label>
          </div>
          <div class="check-cell">
            <label class="check"><input type="radio" name='year_filter' @click=${this._handleYearCheck} data-filtervalue=${new Date().getFullYear() - 1}>${new Date().getFullYear() - 1}</label>
          </div>
          <div class="check-cell">
            <label class="check"><input type="radio" name='year_filter' @click=${this._handleYearCheck} data-filtervalue=${new Date().getFullYear() - 2}>${new Date().getFullYear() - 2}</label>
          </div>
          <div class="check-cell">
            <label class="check"><input type="radio" name='year_filter' @click=${this._handleYearCheck} data-filtervalue=${new Date().getFullYear() - 3}>${new Date().getFullYear() - 3}</label>
          </div>
          <div class="check-cell">
            <label class="check"><input type="radio" name='year_filter' @click=${this._handleYearCheck} data-filtervalue=${new Date().getFullYear() - 4}>${new Date().getFullYear() - 4}</label>
          </div>
        </div>
      </div>
  </div>
    `;
  }

  _handlePaidCheck (event) {
    const detail = {
      message: event.target.checked ? event.target.dataset.filtervalue : "",
    };
    const options = {
      detail,
      bubbles: true,
      composed: true,
    };
    this.dispatchEvent(new CustomEvent("invoices-filtered-paid", options));
  }

  _handleYearCheck (event) {
    const detail = {
      message: event.target.checked ? event.target.dataset.filtervalue : "",
    };
    const options = {
      detail,
      bubbles: true,
      composed: true,
    };
    this.dispatchEvent(new CustomEvent("invoices-filtered-year", options));
  }

  _handleFilterToggle (event) {
    event.preventDefault();
    const link = event.target;
    link.parentElement.classList.toggle("active");
  }
}

export class MyPageInvoicesList extends LitElement {
  static properties = {
    yearfilter: { type: String, state: true, reflect: true },
    paidfilter: { type: String, state: true, reflect: true },
    ssn: { type: String },
  };

  static styles = css`
    :host {
      width: 100%;
    }

    .list__container {
      margin-inline: auto;
      padding-bottom: 30px;
      width: 100%;
      max-width: 1140px; 
      justify-content: space-between;
      /* @media(max-width: 768px) {
        margin-top: 25px;
      } */
    }
    .list__items {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      gap: 30px;
    }

    /* HTML: <div class="loader"></div> */
    .loader {
      align-self: center;
      width: 50px;
      padding: 8px;
      aspect-ratio: 1;
      border-radius: 50%;
      background: var(--spinner-color, var(--primary__color, #444));
      --_m: 
        conic-gradient(#0000 10%,#000),
        linear-gradient(#000 0 0) content-box;
      -webkit-mask: var(--_m);
              mask: var(--_m);
      -webkit-mask-composite: source-out;
              mask-composite: subtract;
      animation: l3 1s infinite linear;
    }
    @keyframes l3 {to{transform: rotate(1turn)}}
  `;

  // constructor() {
  //   super();
  // }

  render () {
    let year = new Date().getFullYear();
    if (this.yearfilter !== undefined && this.yearfilter !== "") {
      year = this.yearfilter;
    }
    let paid = ["YES", "NO"];
    if (this.paidfilter !== undefined && this.paidfilter !== "") {
      paid = this.paidfilter;
    }
    const invoiceList = document.querySelector("mypage-invoices-list");
    const socialSecurityNumber = this.ssn;
    const company = window.serverdata.configMeta.aim.nameId;

    getInvoices(socialSecurityNumber, company, year).then((data) => {
      invoiceList.replaceChildren();
      if (data?.body?.status === "0") {
        const invoices = data?.body?.citizen?.invoices;
        invoices.sort((a, b) => b.dueDate - a.dueDate);
        for (const item of invoices) {
          if (paid.includes(item.paid)) {
            const invoiceCard = document.createElement("mypage-invoice-item");
            invoiceCard.item = item;
            invoiceList.appendChild(invoiceCard);
          }
        }
        if (invoiceList.children.length < 1) {
          const invoiceError = document.createElement("mypage-invoice-error");
          invoiceError.message = language("MYPAGE_INVOICE_NOINVOICE");
          invoiceList.appendChild(invoiceError);
        }
      } else {
        const invoiceError = document.createElement("mypage-invoice-error");
        invoiceError.message = data?.body?.message;
        invoiceList.appendChild(invoiceError);
      }
    });
    return html`<div class="list__container">
                  <div class="list__items">
                    <slot><div class="loader"></div></slot>
                  </div>
                </div>`;
  }
}

export class MyPageInvoiceItem extends LitElement {
  static properties = {
    item: { type: Object, reflect: true },
  };

  static styles = css`
    .item {
      background: #ffffff;
      border-radius: 6px;
      padding: 20px 25px 20px 25px;
      display: flex;
      flex-direction: row;
      gap: 15px;
      align-items: flex-start;
      justify-content: flex-start;
      flex-shrink: 0;
      position: relative;
      cursor: pointer;
			/* &:hover {
				box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.25);
			} */
      @media(max-width: 768px) {
        align-items: flex-start;
        padding: 15px;
      }
    }
    .icon {
      display: flex;
      padding-top: 5px;
      img {
        height: 50px;
      }
    }
    .content {
      display: flex;
      flex-direction: column;
      gap: 7px;
      align-items: flex-start;
      justify-content: flex-start;
      align-self: stretch;
      flex: 1;
      position: relative;
      align-items: flex-start;
      flex-shrink: 0;
      & a {
        display: flex;
        align-items: center;
        gap: 2px;
      }
      & a:hover, & a:link, & a:visited {
        color: var(--default-500, #1e1e1e);
        text-decoration: none;
      }
      & a:hover {
        text-decoration: underline;
      }
    }
    .status {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 10px;
    }
    .title {
      color: var(--default-500, #1e1e1e);
      text-align: left;
      font-size: var(--raelingen-h3-font-size, 20px);
      text-transform: capitalize;
      line-height: var(--raelingen-h3-line-height, 150%);
      font-weight: var(--raelingen-h3-font-weight, 600);
      & svg {
        margin: 2px 0 0 5px;
        position: absolute;
      }
      @media(max-width: 768px) {
        font-size: var(--raelingen-h3-font-size, 18px);
      }
    }
    .text {
      color: var(--default-500, #1e1e1e);
      text-align: left;
      font-size: 16px;
      line-height: 135%;
      font-weight: 400;
      position: relative;
      align-self: stretch;
      display: flex;
      flex-direction: row;
      gap: 10px;

      @media(max-width: 768px) {
        flex-direction: column;
        text-wrap: balance;
      }
    }
    .more-icon {
      display: flex;
      flex-direction: column;
      gap: 10px;
      align-items: flex-end;
      justify-content: center;
      align-self: stretch;
      flex-shrink: 0;
      position: relative;
    }
    .arrow-forward {
      flex-shrink: 0;
      width: 32px;
      height: 32px;
      position: relative;
      overflow: visible;
    }
    .pill {
      background: #eeeeee;
      border-radius: 40px;
      padding: 4px 10px;
      font-size: 1rem;
      line-height: 100%;
      width: max-content
    }
    .amount {
      font-weight: 600;
      margin-top: -2px;
    }
    .paid {
      background: #d6f3c0;
    }
    .postpone {
      display: none;
    }
    .postpone.available{
      display: flex;
      cursor: pointer;
      background: transparent;
      &:hover {
        background: #FFE8BA;
        border-radius: 40px;
        padding: 4px 10px;
        font-size: 1rem;
        line-height: 100%;
        width: max-content
      }
      & div {
        font-size: 1rem;
        padding-top: 2px;
      }
      & svg {
        padding: 0px 4px 0px 0px;
      }
    }
    .postpone-dialog {
      padding: 50px 30px 40px 30px;
      border-radius: 6px;
      background: #FFF;
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
      border: none;
      & .dlg-close {
        position: absolute;
        top: 10px;
        right: 10px;
      }
      & .dlg-wrapper {
        display: inline-flex;
        align-items: flex-start;
        flex-direction: column;
        gap: 30px;
      }
      & .dlg-title {
        color: var(--black__text, #1E1E1E);
        font-size: 21px;
        font-weight: var(--f-w-3);
      }
      & .dlg-text {
        color: var(--black__text, #1E1E1E);
        font-size: 18px;
        max-width: 310px;
      }
      & .dlg-button-row {
        display: flex;
        align-items: flex-start;
        gap: 10px;
      }
      & button {
        display: flex;
        padding: 16px 32px;
        align-items: flex-start;
        gap: 12px;
        border: 2px solid var(--primary__color, #004459);
        font-size: 18px;
        font-weight: 500;
        line-height: 24px;
        cursor: pointer;
      }
      & button.disabled {
        cursor: default;
        opacity: .5;
      }
      & button.dlg-cancel {
        border-radius: 4px;
        background: #FFF;
        color: var(--primary__color, #004459);
      }
      & button.dlg-ok {
        border-radius: 4px;
        background: var(--primary__color, #004459);
        color: var(--white__text)
      }
      &::backdrop {
        /* opacity: 0.75; */
        background-color: rgba(0, 0, 0, 0.60);
      }
    }
    `;

  // constructor() {
  //   super();
  // }

  render () {
    let icon = window.serverdata.configMeta.aim.favicon;
    if (this.item.fiksOrganisasjon?.kommunenummer !== undefined) {
      icon = `https://static.fiks.ks.no/img/kommunevaapen/${this.item.fiksOrganisasjon?.kommunenummer}.png`;
    }

    const dueDate =
      this.item.reminderPostponed !== 0
        ? this.item.reminderPostponed.toString().replace(/(\d{4})(\d{2})(\d{2})/g, "$1-$2-$3")
        : this.item.dueDate.toString().replace(/(\d{4})(\d{2})(\d{2})/g, "$1-$2-$3");
    const amount = this.item.payableAmount.toLocaleString("no-NO");
    const showPostpone = this.item.paid === "NO" && this.item.reminderPostponed === 0 && window.serverdata.configMeta.aim?.mysite?.invoice?.postpone;

    return html`
      <div class="item">
        <div class="icon">
          <img loading="lazy" src="${icon}" />
        </div>
        <div class="content">
          <a href="${window.serverdata.configMeta?.integrations?.visma?.download}?docId=${this.item.attachments[0].docId}" alt="${this.item.attachments[0].name}">
            <div class="title">
              ${this.item.attachments[0].name.split(".").slice(0, -1).join(".")} (PDF)
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" width="24px" viewBox="0 -960 960 960" fill="var(--black__text)"><path d="M480-320 280-520l56-58 104 104v-326h80v326l104-104 56 58-200 200ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z"/></svg>
            </div>
          </a>
          <div class="text">
          <span class="pill amount">${amount} ${language("MYPAGE_INVOICE_CURRENCY")}</span>
            ${this.item.ledgerTypeName} &#8226; ${this.item.reminderPostponed === 0 ? language("MYPAGE_INVOICE_DUEDATE") : language("MYPAGE_INVOICE_POSTPONEDDUEDATE")}: ${dayjs(dueDate).format("DD.MM.YYYY")}
          </div>
        </div>
        <div class="status">
          <span class="pill${this.item.unpaidAmount <= 0 ? " paid" : ""}">${this.item.unpaidAmount <= 0 ? language("MYPAGE_INVOICE_FILTER_STATE_PAID") : language("MYPAGE_INVOICE_FILTER_STATE_NOTPAID")}</span>
          <div class="pill postpone${showPostpone ? " available" : ""}" @click=${this._handlePostponeOpenClick} data-invoiceNumber=${this.item.invoiceNumber}>
            <svg xmlns="http://www.w3.org/2000/svg" height="20px" width="20px" viewBox="0 -960 960 960" fill="var(--black__text)"><path d="M200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Z"/></svg>
            <div>${language("MYPAGE_INVOICE_FILTER_STATE_POSTPONE")}</div>
          </div>
        </div>
      </div>
      <dialog class="postpone-dialog">
          <div class="dlg-close" @click=${this._handleCloseClick}>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
              <mask id="mask0_2654_2693" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
              <rect width="32" height="32" fill="#D9D9D9"/>
              </mask>
              <g mask="url(#mask0_2654_2693)">
              <path d="M8.53335 25.3327L6.66669 23.466L14.1334 15.9993L6.66669 8.53268L8.53335 6.66602L16 14.1327L23.4667 6.66602L25.3334 8.53268L17.8667 15.9993L25.3334 23.466L23.4667 25.3327L16 17.866L8.53335 25.3327Z" fill="#1E1E1E"/>
              </g>
            </svg>
          </div>
          <div class="dlg-wrapper">
            <div>
              <div class="dlg-title">${language("MYPAGE_INVOICE_DLG_TITLE")}</div>
              <div class="dlg-text">${language("MYPAGE_INVOICE_DLG_TEXT")}</div>
            </div>
            <div class="dlg-button-row">
              <button class="dlg-cancel" value="cancel" @click=${this._handleCancelClick}>${language("MYPAGE_INVOICE_DLG_CANCEL")}</button>
              <button class="dlg-ok" value="default" @click=${this._handlePostponeClick} data-invoiceNumber=${this.item.invoiceNumber}>${language("MYPAGE_INVOICE_DLG_OK_ACTION")}</button>
            </div>
          </div>
      </dialog>
      `;
  }

  _handleCloseClick (event) {
    const postponeDialog = event.target.closest(".postpone-dialog");
    postponeDialog.close();
  }
  _handlePostponeOpenClick (event) {
    const postponeDialog = event.target.closest(".item").nextElementSibling;
    postponeDialog.showModal();
  }
  _handlePostponeClick (event) {
    const postponeDialog = event.target.closest(".postpone-dialog");
    const company = window.serverdata.configMeta.aim?.visma?.company || window.serverdata.configMeta.aim.nameId;

    postponeCall(company, event.currentTarget.dataset.invoicenumber).then((data) => {
      postponeDialog.getElementsByClassName("dlg-title")[0].innerText = language("MYPAGE_INVOICE_DLG_TITLE_RESPONSE"); // "Utsettelse"; //`Faktura ${data.invoiceNumber}`;
      if (data.postponementStatus.includes("Utsettelse ok")) {
        postponeDialog.getElementsByClassName("dlg-text")[0].innerHTML = `${data.postponementStatus}<br/>Ny forfallsdato er ${data.reminderPostponed}`;
      } else if (data.postponementStatus.includes("allerede utsatt")) {
        postponeDialog.getElementsByClassName("dlg-text")[0].innerHTML = `${data.postponementStatus} til ${new Date(data.reminderPostponed).toLocaleDateString("nb-NO")}`;
      } else if (data.postponementStatus.includes("er betalt")) {
        postponeDialog.getElementsByClassName("dlg-text")[0].innerHTML = data.postponementStatus; //"Faktura er betalt";
      } else {
        postponeDialog.getElementsByClassName("dlg-text")[0].innerHTML = `Noe gikk galt: ${data.postponementStatus}`; //"Faktura er betalt";
      }

      postponeDialog.getElementsByClassName("dlg-ok")[0].disabled = true;
      postponeDialog.getElementsByClassName("dlg-ok")[0].classList.add("disabled");
    });
  }
  _handleCancelClick (event) {
    const postponeDialog = event.target.closest(".postpone-dialog");
    postponeDialog.close();
  }
}

export class MyPageInvoiceError extends LitElement {
  static properties = {
    message: { type: String },
  };

  static styles = css`
    .item {
      background: #ffffff;
      border-radius: 6px;
      padding: 20px 25px 20px 25px;
      display: flex;
      flex-direction: row;
      gap: 20px;
      align-items: center;
      justify-content: flex-start;
      flex-shrink: 0;
      position: relative;
    }
    .icon {
      padding: 5px 0px 0px 0px;
      display: flex;
      flex-direction: row;
      gap: 10px;
      align-items: flex-start;
      justify-content: flex-start;
      flex-shrink: 0;
      position: relative;
      flex-shrink: 0;
      width: 37px;
      height: auto;
      position: relative;
      img {
        // width: 32px;
        height: 50px;
      }
    }
    .content {
      display: flex;
      flex-direction: column;
      gap: 10px;
      align-items: flex-start;
      justify-content: flex-start;
      align-self: stretch;
      flex: 1;
      position: relative;
      display: flex;
      flex-direction: column;
      gap: 0px;
      align-items: flex-start;
      justify-content: flex-start;
      align-self: stretch;
      flex-shrink: 0;
      position: relative;
    }
    .title {
      display: flex;
      flex-direction: row;
      gap: 0px;
      align-items: flex-start;
      justify-content: flex-start;
      align-self: stretch;
      flex-shrink: 0;
      position: relative;
      color: var(--default-500, #1e1e1e);
      text-align: left;
      font-family: var(
        --raelingen-h3-font-family,
        "SourceSansPro-SemiBold",
        sans-serif
      );
      font-size: var(--raelingen-h3-font-size, 20px);
      line-height: var(--raelingen-h3-line-height, 150%);
      font-weight: var(--raelingen-h3-font-weight, 600);
      position: relative;
      flex: 1;
    }
    .text {
      color: var(--default-500, #1e1e1e);
      text-align: left;
      font-family: "SourceSansPro-Regular", sans-serif;
      font-size: 16px;
      line-height: 135%;
      font-weight: 400;
      position: relative;
      align-self: stretch;
    }
    .more-icon {
      display: flex;
      flex-direction: column;
      gap: 10px;
      align-items: flex-end;
      justify-content: center;
      align-self: stretch;
      flex-shrink: 0;
      position: relative;
    }
    .arrow-forward {
      flex-shrink: 0;
      width: 32px;
      height: 32px;
      position: relative;
      overflow: visible;
    }
    .pill {
      background: #eeeeee;
      border-radius: 40px;
      padding: 4px 11px 4px 11px;
    }
    .amount {
      font-weight: 600;
    }
    .paid {
      background: #d6f3c0;
    }`;

  // constructor() {
  //   super();
  // }

  render () {
    return html`${this.message}`;
  }
}

customElements.define("mypage-invoices", MyPageInvoices);
customElements.define("mypage-invoices-filter", MyPageInvoicesFilter);
customElements.define("mypage-invoices-list", MyPageInvoicesList);
customElements.define("mypage-invoice-item", MyPageInvoiceItem);
customElements.define("mypage-invoice-error", MyPageInvoiceError);

const getInvoices = async (ssn, company, year) => {
  if (!window.location.host.match(/localhost/gim)) {
    const apiCall = window.serverdata.configMeta?.integrations?.visma?.invoices;
    const apiParameters = `?company=1&year=${year}&pnr=${ssn}`;

    return await fetch(apiCall + apiParameters)
      .then((results) => {
        if (results.ok) {
          return results.json();
        }
        return Promise.reject(results);
      })
      .then((data) => {
        return data;
      })
      .catch((error) => {
        console.log(error.status, error.statusText);
        // get error messages, if any
        error.json().then((text) => {
          console.log(text);
        });
      });
  }

  return JSON.parse(`
  {
  "body": {
    "status": "0",
    "citizen": {
      "name": "EIKELAND HEIDI",
      "address1": "RUNNHOVDA 44",
      "zipCode": "5281",
      "postalArea": "VALESTRANDSFOSSEN             ",
      "companyName": "Osterøy kommune",
      "company": "1",
      "countryCode": "NO",
      "emailAddress": "",
      "customerNumber": "25058343083",
      "invoices": [
        {
          "ledgerType": "K090",
          "postedLoss": false,
          "unpostedVoucher": false,
          "attachments": [
            {
              "name": "faktura-90002394.pdf",
              "docId": "2zrJ8",
              "form": "YES"
            }
          ],
          "reminders": [],
          "interests": [],
          "distributed": "YES",
          "payableAmount": "10",
          "credited": "NO",
          "payerName": "EIKELAND HEIDI",
          "ledgerTypeName": "Kunder Diverse",
          "unpaidAmount": "10",
          "paid": "NO",
          "dueDate": 20241025,
          "reminderPostponed": 20241124,
          "bankAccount": "36335498164",
          "invoiceDate": "20240925",
          "invoiceNumber": "90002394",
          "distributionChannel": "eFaktura - privat",
          "invoiceCustomerId": "00304070090000023"
        },
        {
          "ledgerType": "K090",
          "postedLoss": false,
          "unpostedVoucher": false,
          "attachments": [
            {
              "name": "faktura-90002395.pdf",
              "docId": "oK5mr",
              "form": "YES"
            }
          ],
          "reminders": [],
          "interests": [],
          "distributed": "YES",
          "payableAmount": "10",
          "credited": "NO",
          "payerName": "EIKELAND HEIDI",
          "ledgerTypeName": "Kunder Diverse",
          "unpaidAmount": "10",
          "paid": "NO",
          "dueDate": 20241001,
          "reminderPostponed": 20241031,
          "bankAccount": "36335498164",
          "invoiceDate": "20241001",
          "invoiceNumber": "90002395",
          "distributionChannel": "Blankett",
          "invoiceCustomerId": "00304070090000031"
        },
        {
          "ledgerType": "K090",
          "postedLoss": false,
          "unpostedVoucher": false,
          "attachments": [
            {
              "name": "faktura-90002396.pdf",
              "docId": "g2dXX",
              "form": "YES"
            }
          ],
          "reminders": [],
          "interests": [],
          "distributed": "YES",
          "payableAmount": "10",
          "credited": "NO",
          "payerName": "EIKELAND HEIDI",
          "ledgerTypeName": "Kunder Diverse",
          "unpaidAmount": "10",
          "paid": "NO",
          "dueDate": 20241015,
          "reminderPostponed": 0,
          "bankAccount": "36335498164",
          "invoiceDate": "20241001",
          "invoiceNumber": "90002396",
          "distributionChannel": "Blankett",
          "invoiceCustomerId": "00304070090000049"
        },
        {
          "ledgerType": "K100",
          "postedLoss": false,
          "unpostedVoucher": false,
          "attachments": [
            {
              "name": "faktura-100090260.pdf",
              "docId": "n1Mqn",
              "form": "YES"
            }
          ],
          "reminders": [],
          "interests": [],
          "distributed": "YES",
          "payableAmount": "4660.24",
          "credited": "NO",
          "payerName": "EIKELAND HEIDI",
          "ledgerTypeName": "Kunder kommunale eigedomsgebyr",
          "unpaidAmount": "0",
          "paid": "YES",
          "dueDate": 20240327,
          "reminderPostponed": 0,
          "bankAccount": "36335498164",
          "invoiceDate": "20240306",
          "invoiceNumber": "100090260",
          "distributionChannel": "eFaktura - privat",
          "invoiceCustomerId": "00304070100000195"
        },
        {
          "ledgerType": "K100",
          "postedLoss": false,
          "unpostedVoucher": false,
          "attachments": [
            {
              "name": "faktura-100091396.pdf",
              "docId": "g20wm",
              "form": "YES"
            }
          ],
          "reminders": [],
          "interests": [],
          "distributed": "YES",
          "payableAmount": "1557.73",
          "credited": "NO",
          "payerName": "EIKELAND HEIDI",
          "ledgerTypeName": "Kunder kommunale eigedomsgebyr",
          "unpaidAmount": "0",
          "paid": "YES",
          "dueDate": 20240419,
          "reminderPostponed": 0,
          "bankAccount": "36335498164",
          "invoiceDate": "20240405",
          "invoiceNumber": "100091396",
          "distributionChannel": "eFaktura - privat",
          "invoiceCustomerId": "00304070100000203"
        },
        {
          "ledgerType": "K100",
          "postedLoss": false,
          "unpostedVoucher": false,
          "attachments": [
            {
              "name": "faktura-100091617.pdf",
              "docId": "Z46Bz",
              "form": "YES"
            }
          ],
          "reminders": [],
          "interests": [],
          "distributed": "YES",
          "payableAmount": "1557.73",
          "credited": "NO",
          "payerName": "EIKELAND HEIDI",
          "ledgerTypeName": "Kunder kommunale eigedomsgebyr",
          "unpaidAmount": "0",
          "paid": "YES",
          "dueDate": 20240520,
          "reminderPostponed": 0,
          "bankAccount": "36335498164",
          "invoiceDate": "20240503",
          "invoiceNumber": "100091617",
          "distributionChannel": "eFaktura - privat",
          "invoiceCustomerId": "00304070100000211"
        },
        {
          "ledgerType": "K100",
          "postedLoss": false,
          "unpostedVoucher": false,
          "attachments": [
            {
              "name": "faktura-100091836.pdf",
              "docId": "AYyLA",
              "form": "YES"
            }
          ],
          "reminders": [],
          "interests": [],
          "distributed": "YES",
          "payableAmount": "1557.73",
          "credited": "NO",
          "payerName": "EIKELAND HEIDI",
          "ledgerTypeName": "Kunder kommunale eigedomsgebyr",
          "unpaidAmount": "0",
          "paid": "YES",
          "dueDate": 20240620,
          "reminderPostponed": 0,
          "bankAccount": "36335498164",
          "invoiceDate": "20240604",
          "invoiceNumber": "100091836",
          "distributionChannel": "eFaktura - privat",
          "invoiceCustomerId": "00304070100000229"
        },
        {
          "ledgerType": "K100",
          "postedLoss": false,
          "unpostedVoucher": false,
          "attachments": [
            {
              "name": "faktura-100095730.pdf",
              "docId": "4JwrR",
              "form": "YES"
            }
          ],
          "reminders": [],
          "interests": [],
          "distributed": "YES",
          "payableAmount": "1557.73",
          "credited": "NO",
          "payerName": "EIKELAND HEIDI",
          "ledgerTypeName": "Kunder kommunale eigedomsgebyr",
          "unpaidAmount": "0",
          "paid": "YES",
          "dueDate": 20240720,
          "reminderPostponed": 0,
          "bankAccount": "36335498164",
          "invoiceDate": "20240704",
          "invoiceNumber": "100095730",
          "distributionChannel": "eFaktura - privat",
          "invoiceCustomerId": "00304070100000237"
        },
        {
          "ledgerType": "K100",
          "postedLoss": false,
          "unpostedVoucher": false,
          "attachments": [
            {
              "name": "faktura-100096907.pdf",
              "docId": "R6zNm",
              "form": "YES"
            }
          ],
          "reminders": [],
          "interests": [],
          "distributed": "YES",
          "payableAmount": "1557.73",
          "credited": "NO",
          "payerName": "EIKELAND HEIDI",
          "ledgerTypeName": "Kunder kommunale eigedomsgebyr",
          "unpaidAmount": "0",
          "paid": "YES",
          "dueDate": 20240820,
          "reminderPostponed": 0,
          "bankAccount": "36335498164",
          "invoiceDate": "20240802",
          "invoiceNumber": "100096907",
          "distributionChannel": "eFaktura - privat",
          "invoiceCustomerId": "00304070100000245"
        },
        {
          "ledgerType": "K100",
          "postedLoss": false,
          "unpostedVoucher": false,
          "attachments": [
            {
              "name": "faktura-100097186.pdf",
              "docId": "77ZV4",
              "form": "YES"
            }
          ],
          "reminders": [],
          "interests": [],
          "distributed": "YES",
          "payableAmount": "1557.73",
          "credited": "NO",
          "payerName": "EIKELAND HEIDI",
          "ledgerTypeName": "Kunder kommunale eigedomsgebyr",
          "unpaidAmount": "0",
          "paid": "YES",
          "dueDate": 20240920,
          "reminderPostponed": 20241020,
          "bankAccount": "36335498164",
          "invoiceDate": "20240905",
          "invoiceNumber": "100097186",
          "distributionChannel": "eFaktura - privat",
          "invoiceCustomerId": "00304070100000252"
        },
        {
          "ledgerType": "K100",
          "postedLoss": false,
          "unpostedVoucher": false,
          "attachments": [
            {
              "name": "faktura-100097480.pdf",
              "docId": "OEqz5",
              "form": "YES"
            }
          ],
          "reminders": [],
          "interests": [],
          "distributed": "YES",
          "payableAmount": "1557.73",
          "credited": "NO",
          "payerName": "EIKELAND HEIDI",
          "ledgerTypeName": "Kunder kommunale eigedomsgebyr",
          "unpaidAmount": "1557.73",
          "paid": "NO",
          "dueDate": 20241020,
          "reminderPostponed": 0,
          "bankAccount": "36335498164",
          "invoiceDate": "20241001",
          "invoiceNumber": "100097480",
          "distributionChannel": "eFaktura - privat",
          "invoiceCustomerId": "00304070100000260"
        }
      ]
    }
  },
  "statusCode": "OK",
  "statusCodeValue": "200",
  "year": "2024"
}`);
};

const postponeCall = async (company, invoiceNr) => {
  const apiCall = window.serverdata.configMeta?.integrations?.visma?.postpone;
  const apiParameters = `?company=1&invoiceNr=${invoiceNr}`;

  return await fetch(apiCall + apiParameters)
    .then((results) => results.json())
    .then((data) => {
      return data?.body;
    });

  // Allerede betalt:
  // {"headers":{},"body":{"invoiceNumber":"100096907","reminderPostponed":"","postponementStatus":"Fakturaen er betalt"},"statusCode":"BAD_REQUEST","statusCodeValue":400}

  // Ikke betalt:
  // {"headers":{},"body":{"invoiceNumber":"100097186","reminderPostponed":"2024-10-20","postponementStatus":"Utsettelse ok"},"statusCode":"OK","statusCodeValue":200}

  // Allerede utsatt:
  // {"headers":{},"body":{"invoiceNumber":"100097186","reminderPostponed":"2024-10-20","postponementStatus":"Fakturaen er allerede utsatt"},"statusCode":"BAD_REQUEST","statusCodeValue":400}

  // For mange utsettelser?
  // {"headers": {},"body": {"invoiceNumber": "090002396","reminderPostponed": "","postponementStatus": "Maks antall fakturaer er overskredet"},"statusCode": "BAD_REQUEST","statusCodeValue": 400}

  // This is what is returned
  // {
  // 	invoiceNumber: "100097186",
  // 	reminderPostponed: "2024-10-20",
  // 	postponementStatus: "Utsettelse ok",
  // }
};
